import { T } from './design-tokens';

/** API task state → design label + colors (dark theme) */
export const TASK_STATE_CONFIG: Record<
  string,
  { label: string; color: string; bg: string }
> = {
  CLASSIFIED: { label: 'Starting', color: T.cream35, bg: T.cream04 },
  AWAITING_APPROVAL: { label: 'Needs You', color: T.gold, bg: T.goldDim },
  APPROVED: { label: 'Planning', color: T.amber, bg: T.amberDim },
  EXECUTING: { label: 'Running', color: T.green, bg: T.greenDim },
  COMPLETED: { label: 'Done', color: T.green, bg: T.greenDim },
  FAILED: { label: 'Failed', color: T.red, bg: T.redDim },
  CANCELLED: { label: 'Aborted', color: T.cream35, bg: T.cream04 },
  WAITING_RESPONSE: { label: 'Waiting', color: T.cream60, bg: T.cream08 },
  NO_RESPONSE: { label: 'No Response', color: T.red, bg: T.redDim },
};

export const TIER_LIMITS = {
  starter: { calls: 5, emails: 10 },
  pro: { calls: 10, emails: 50 },
  max: { calls: 50, emails: 9999 },
} as const;
